import React from 'react';
import { StreamChat } from 'stream-chat';
import {
  Chat,
  Channel,
  MessageInput,
  VirtualizedMessageList,
  Thread,
  Window,

  Streami18n,
} from 'stream-chat-react';
import 'stream-chat-react/dist/css/index.css';
import './App.css';
import { CustomMessage } from './components/Customessage';
import { CustomMessageInput } from './components/sendmessage/sendMessage';
import { PinnedMessageList  } from './components/PinnedMessageList/PinnedMessageList';
import { DateSeparator } from 'stream-chat-react';


const urlParams = new URLSearchParams(window.location.search);
const apiKey = urlParams.get('api_key');
const userId = urlParams.get('user_id');
const channelId = urlParams.get('channel_id');
const theme = urlParams.get('theme') || 'light';
const userToken = urlParams.get('user_token');
const lang = urlParams.get('lang') ? urlParams.get('lang') : 'en';
const i18n = new Streami18n({ language: lang });
const chatClient = StreamChat.getInstance(apiKey);

chatClient.connectUser({ id: userId }, userToken);

const channel = chatClient.channel('messaging', channelId, {});
export const YourCustomDateSeparator = (props) => {
  const { date } = props;

  function formatDate(d) {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (d.toDateString() === today.toDateString()) {
        const todayTranslation = lang === 'fr' ? "—AUJOURD'HUI—" : (lang === 'es' ? "—HOY—" : "—TODAY—");
        return todayTranslation;

    } else if (d.toDateString() === yesterday.toDateString()) {
        const yesterdayTranslation = lang === 'fr' ? "—HIER—" : (lang === 'es' ? "—AYER—" : "—YESTERDAY—");
        return yesterdayTranslation;

    } else {
      const day = d.getDate();
      const month = d.toLocaleString(lang, { month: 'short' }).toUpperCase();
  
      return lang === 'fr' ? `—${day} ${month}—` : (lang === 'es' ? `—${day} ${month}—` : `—${month} ${day}—`);
    }
}

  return (
      <DateSeparator
          formatDate={formatDate}
          date={date}
          position={'left'}
      />
  );
};



channel.getConfig = () => ({
  mutes: true,
});


const App = () => (
  <Chat client={chatClient} theme={`messaging ${theme}`} i18nInstance={i18n}>
    <Channel channel={channel} Input={CustomMessageInput} DateSeparator={YourCustomDateSeparator}>
    <PinnedMessageList chatClient={chatClient} channelId={channelId}/>

      <Window>
      <VirtualizedMessageList  Message={CustomMessage} scrollToLatestMessageOnFocus={true} defaultItemHeight={76} disableDateSeparator={false} />
      <MessageInput grow={true} maxRows={5} />
      </Window>

    </Channel>
  </Chat>
);

export default App;
